module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-2021-2.59a78c26.jpg";